<template>
  <el-dialog
      v-el-drag-dialog
      :title="disabled ? '详情' : role.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      class="adaptationModal"
      width="1100px"
      :close-on-click-modal="false"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :rules="ruleValidate"
        :model="role"
        class="form"
        label-width="80px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="role.roleName" placeholder="请输入角色名称"/>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="role.note" placeholder="请输入" autosize type="textarea"/>
      </el-form-item>
      <el-form-item label="功能权限">
        <el-table
            :data="functions"
            border
            style="width: 100%"
            :show-header="true"
            class="cus-table">
          <el-table-column prop="label" label="组" width="220">
            <template slot-scope="scope">
              <el-checkbox
                  :value="role.fauthorization[scope.row.other] === '1'"
                  :label="scope.row.label"
                  @change="checkRowChange(scope.row)"
              >
                {{scope.row.label}}
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="children" label="功能">
            <template slot-scope="scope">
              <el-checkbox
                  v-for="(item, index) in scope.row.children"
                  :key="index"
                  :value="role.fauthorization[item.other] === '1'"
                  :label="item.label"
                  @change="checkChange(item)"
              >
                {{item.label}}
              </el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "RoleEdit",
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        role: {
          id: 0,
          roleName: "",
          note: "",
          fauthorization:
            "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
        },
        functions: [],
        ruleValidate: {
          roleName: [
            {
              required: true,
              trigger: "blur",
              message: "请输入角色名称",
            },
          ],
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = !!mark;
        this.getFunctionData();
        if (row) {
          this.getData(row.id);
        }
      },

      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `roles/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.role = Object.assign(this.role, resp.data);
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      getFunctionData() {
        this.$http.get("basic", "functions/tree").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              item.children.forEach((s) => {
                this.functions.push(s);
              });
            });
          }
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "roles", this.role)
              .then((resp) => {
                if (resp.success) {
                  this.$emit("save-success");
                  if (!this.role.id) {
                    this.$message.success("添加成功");
                  } else {
                    this.$message.success("编辑成功");
                  }
                }
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      checkRowChange(obj) {
        let val = this.change(obj.other);
        let parentId = obj.id;
        for (let item of this.functions) {
          if (item.id == parentId) {
            for (let child of item.children) {
              this.change(child.other, val);
            }
          }
        }
      },

      checkChange(obj) {
        let val = this.change(obj.other);
        let parentId = obj.parentId;
        for (let item of this.functions) {
          if (item.id == parentId) {
            for (let child of item.children) {
              if (this.role.fauthorization[child.other] != val) {
                if (val == "0") {
                  this.change(item.other, val);
                }
                return;
              }
            }
            this.change(item.other, val);
          }
        }
      },

      change(index, val) {
        if (val) {
          this.role.fauthorization =
            this.role.fauthorization.substring(0, index) +
            val +
            this.role.fauthorization.substring(index + 1, this.role.fauthorization.length);
          return "";
        }
        if (this.role.fauthorization[index] == 0) {
          this.role.fauthorization =
            this.role.fauthorization.substring(0, index) +
            "1" +
            this.role.fauthorization.substring(index + 1, this.role.fauthorization.length);
          return "1";
        } else {
          this.role.fauthorization =
            this.role.fauthorization.substring(0, index) +
            "0" +
            this.role.fauthorization.substring(index + 1, this.role.fauthorization.length);
          return "0";
        }
      },
    },
  };
</script>
<style scoped>
  ::v-deep .el-table{
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #2d8cf0;
      border-color: #2d8cf0;
      &::after {
        border-color: #fff;
      }
    }
    .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #409eff;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner{
      background-color: #fff;
      border-color: #dcdfe6;
    }
    .el-checkbox .el-checkbox__label{
      font-size: 12px!important;
      color: #606266;
    }
    .el-table__body-wrapper{
      height: 70vh;
      overflow-y: auto;
    }
  }
</style>
